const AUDIENCES = [
  {
    id: 'rights-holders',
    title: 'Rights Holders',
    body: 'Make it easier to communicate how your content can be used, preserve its context and support direct licensing without giving up control of the asset.',
    // href: '/solutions/rights-holders',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 3 19 6v5c0 4.2-2.7 8-7 10-4.3-2-7-5.8-7-10V6l7-3Z" />
        <path d="M9.5 12.5 11.3 14.3 15 10" />
      </svg>
    ),
  },
  {
    id: 'marketing-legal',
    title: 'Marketing Compliance',
    body: 'Understand what applies, make permissions clear and keep evidence of the decisions behind content use.',
    // href: '/solutions/marketing-legal-compliance',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M6 4h12a2 2 0 0 1 2 2v14H4V6a2 2 0 0 1 2-2Z" />
        <path d="M8 8h8M8 12h8M8 16h5" />
      </svg>
    ),
  },
  {
    id: 'government-news',
    title: 'Government & News',
    body: 'Give teams and audiences stronger signals about where content came from, how it has changed and what disclosures travel with it.',
    // href: '/solutions/government-news',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M3 10h18M5 10v8M9 10v8M15 10v8M19 10v8M3 18h18M12 3l9 5H3l9-5Z" />
      </svg>
    ),
  },
  {
    id: 'law-firms',
    title: 'Law Firms',
    body: 'Help clients review requirements, create policies, manage permissions and apply provenance without rebuilding the same process every time.',
    // href: '/solutions/law-firms',
    icon: (
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 3v18M7 6h10M5 6l-3 6h6L5 6ZM19 6l-3 6h6l-3-6ZM8 21h8" />
      </svg>
    ),
  },
]

const WhoTikBoxIsFor = () => {
  return (
    <section className="tikbox-who-for" aria-labelledby="who-tikbox-is-for-title">
      <div className="tikbox-who-for__container">
        <header className="tikbox-who-for__header">
          <p className="tikbox-who-for__eyebrow">Who TikBox is for</p>
          <h2 id="who-tikbox-is-for-title">
            Built for organisations that rely on digital content
          </h2>
          <p>
            Every organisation depends on digital content. But in the AI age, knowing where it came from, what can be done with it, and how to manage it responsibly is getting harder. TikBox provides the tools to bring more clarity, control, and confidence to that content - shaped around the needs of different industries and teams.
          </p>
        </header>

        <div className="tikbox-who-for__grid">
          {AUDIENCES.map((audience) => (
            <a
              key={audience.id}
              className="tikbox-who-for__card"
              href={audience.href}
              aria-label={`${audience.title}: ${audience.body}`}
            >
              <span className="tikbox-who-for__icon" aria-hidden="true">
                {audience.icon}
              </span>

              <h3>{audience.title}</h3>
              <p>{audience.body}</p>

              <span className="tikbox-who-for__link-copy" aria-hidden="true">
                {/* Learn more <span>→</span> */}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  )
}

export default WhoTikBoxIsFor
